<div class="chat-logo-block flexbox-row gap-8 p-3 pb-2 justify-content-center">
    <h4 class="title flexbox-row gap-8 text-white">
        <img draggable="false" src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
        LucaAI
    </h4>
    <span class="badge badge-pills badge-border badge-warning-light bg-transparent">BETA</span>
</div>
<div class="flexbox-row flex-nowrap gap-8 p-3 pt-2">
    <mat-form-field class="fixed-label label-none w-100 icon-field-before" [ngClass]="{'disabled': hasNoEngagements()}"
                    floatLabel="always">
        <mat-label>Search history</mat-label>
        <input class="bg-white shadow-none" matInput placeholder="Search history" [formControl]="searchHistory"
               maxlength="20">
        <span matPrefix>
            <i class="fa-regular fa-magnifying-glass"></i>
        </span>
    </mat-form-field>
</div>
<div class="template-block-main flexbox-column gap-0 chat-history flex-1">
    @if (!hasNoSearchChat()) {
        @if (originalChats()?.length > 0) {
            <mat-accordion [multi]="true" class="templates-list">
                @for (history of chatList(); track $index; let index = $index) {
                    @if (history?.displayList?.length > 0) {
                        <mat-expansion-panel [expanded]="history?.isExpanded" (opened)="history.isExpanded = true;"
                                             (closed)="history.isExpanded = false;">
                            <mat-expansion-panel-header class="bg-transparent">
                                <mat-panel-title>
                                    <div class="title-content bg-transparent" title="{{history?.displayKey}}">
                                        <p class="item-title">{{ history?.displayKey }}</p>
                                        <span class="togglable-icon">
                                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                        </span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <mat-list role="list" class="templates-list-items">
                                    @for (list of history?.displayList; track $index) {
                                        <mat-list-item role="listItem">
                                            @if (list?.id !== renameObj()?.id) {
                                                <div class="list-item-content history-list-item"
                                                     matTooltip="{{list?.titleWithDateTime}}"
                                                     matTooltipPosition="right">
                                                    <p class="item-title hover-action"
                                                       (click)="navigateToHistory(list)">
                                                        {{ list?.title }}</p>
                                                    @if (list?.id === currentChatId()) {
                                                        <span class="set-default-dot dot-12 bg-success-new"></span>
                                                    }
                                                    @if (activeEng()?.engId > 0 && !activeEng()?.isRestricted) {
                                                        <button mat-button class="kebab-menu-button"
                                                                [matMenuTriggerFor]="isscmnts"
                                                                #t="matMenuTrigger" (click)="$event.stopPropagation()">
                                                            <i class="fas fa-ellipsis-vertical text-white"></i>
                                                        </button>
                                                    }

                                                    <mat-menu #isscmnts="matMenu" #beforeMenu="matMenu"
                                                              xPosition="before" class="vert-btns">
                                                        <button mat-menu-item title="Rename"
                                                                (click)="renameHistory(list)" class="add-row-btn">
                                                            <span class="flexbox-row gap-8">
                                                                <span class="badge badge-primary p-2">
                                                                    <i class="fa-regular fa-pen fs-14"></i>
                                                                </span>
                                                                <span class="button-label">Rename</span>
                                                            </span>
                                                        </button>
                                                        <button mat-menu-item title="Delete"
                                                                (click)="deleteChatHistory(list)"
                                                                class="add-row-btn">
                                                            <span class="flexbox-row gap-8">
                                                                <span class="badge badge-primary p-2"><i
                                                                    class="fa-regular fa-trash-can fs-14"></i></span>
                                                                <span class="button-label">Delete</span>
                                                            </span>
                                                        </button>
                                                    </mat-menu>
                                                </div>
                                            }
                                            @if (list?.id === renameObj()?.id) {
                                                <mat-form-field
                                                        class=" fixed-label icon-form-after action-2 w-100 form-field-medium"
                                                        floatLabel="always">
                                                    <input matInput type="text" maxlength="50"
                                                           [formControl]="renameCtrl" class="bg-white"
                                                           (click)="$event.stopPropagation()"
                                                           (keydown)="$event.stopPropagation();" #folderRename>

                                                    <div matSuffix class="actions border-start">
                                                        <button mat-button color="success"
                                                                [disabled]="!(renameCtrl?.value?.trim())"
                                                                (click)="confirmRename();$event.stopPropagation()">
                                                            <i class="fa-regular fa-check"></i>
                                                        </button>
                                                        <button mat-button color="cancel"
                                                                (click)="cancelRename();$event.stopPropagation()">
                                                            <i class="fa-regular fa-xmark"></i>
                                                        </button>
                                                    </div>
                                                </mat-form-field>
                                            }
                                        </mat-list-item>
                                    }
                                </mat-list>
                            </ng-template>
                        </mat-expansion-panel>
                    }
                } @empty {
                    <div [ngTemplateOutlet]="noChats"></div>
                }
            </mat-accordion>
        } @else {
            <div [ngTemplateOutlet]="noChats"></div>
        }
    } @else {
        <div [ngTemplateOutlet]="noChats"></div>
    }
</div>

<div class="template-block-main flexbox-column gap-0 chat-history h-initial extra-links-block pb-3 pt-0 overflow-hidden">
    <mat-list role="list" class="templates-list-items">
        <mat-list-item role="listItem" (click)="openFeedbackDialog()" title="Feedback / Report a bug">
            <div class="list-item-content history-list-item bg-transparent border-top">
                <i class="fa-regular fa-thumbs-up text-white"></i>
                <span class="item-title">
                    Feedback / Report a Bug
                </span>
            </div>
        </mat-list-item>
    </mat-list>

    <mat-accordion class="templates-list">
        <mat-expansion-panel>
            <mat-expansion-panel-header class="bg-transparent">
                <mat-panel-title>
                    <div class="title-content bg-transparent" title="Resources & Tutorials">
                        <i class="fa-regular fa-pen-field text-white"></i>
                        <p class="item-title">Resources & Tutorials</p>
                        <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3 text-white"></i>
                        </span>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list role="list" class="templates-list-items">
                <mat-list-item role="listItem" title="Getting Started with luca" (click)="getStarted()">
                    <div class="list-item-content history-list-item bg-transparent">
                        <p class="item-title hover-action ps-4">
                            Getting Started with LucaAI
                        </p>
                    </div>
                </mat-list-item>
                <mat-list-item role="listItem" title="How it Works" (click)="openHowItWorks()">
                    <div class="list-item-content history-list-item bg-transparent">
                        <p class="item-title hover-action ps-4">How it Works</p>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<ng-template #deleteChat>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete Chat?</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>This will delete Financial Statements chat and all the data related to it</p>
            <p>Are you sure you want to proceed with the deletion?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-medium" color="error" [mat-dialog-close]="true">Delete
            </button>
        </div>
    </div>
</ng-template>

<ng-template #feedbackDialog>
    <div class="countable-dialog feedbackDialog" (click)="$event.stopPropagation()"
        style="width:100%; max-width: 600px;">
        <div mat-dialog-title class="dialog-header gap-0">
            <h5 class="title">We'd welcome your suggestions</h5>
            <p class="text-gray-6">Found a bug, or just want to share your feedback?</p>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            <mat-form-field class="fixed-label w-100" floatLabel="always">
                <mat-label>Engagement ID</mat-label>
                <input matInput placeholder="Engagement ID" [value]="activeEng()?.engName" maxlength="20" disabled>
            </mat-form-field>
            <div class="flexbox-column gap-8">
                <h6 class="label">Report Type<span class="text-error">*</span></h6>
                <mat-radio-group class="flexbox-row gap-16" [formControl]="feedBackCtrl">
                    <mat-radio-button value="FEEDBACK">Submit Feedback</mat-radio-button>
                    <mat-radio-button value="BUG">Report a Bug</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="flexbox-column gap-8">
                <h6 class="label">Describe your issue or tell us how can we improve?<span class="text-error">*</span>
                </h6>
                <mat-form-field class="fixed-label label-none form-textarea w-100" floatLabel="always">
                    <mat-label>How can we improve?</mat-label>
                    <textarea class="overflow-y-auto" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                              #textField cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6" [formControl]="description"
                              type="text"
                              placeholder="{{placeHolderText()}}">
                    </textarea>
                </mat-form-field>
            </div>
            <div class="flexbox-column">
                <div class="file-upload" appDragDrop (onFileDropped)="onFileSelected($event,'DND')">
                    <div class="file-wrapper text-center">
                        <p class="text-link text-primary fw-medium m-0">
                            Click to upload
                            <span class="text-gray-6 fw-regular">or drag and drop your files</span>
                            <input type="file" multiple name="fileUpload" #fileUploader
                                   accept="*" (change)="onFileSelected($event,'MANUAL')"/>
                        </p>
                        <p class="text-gray-6 fw-regular">
                            Please feel free to upload any files pertinent to the issue for a more thorough assessment.
                        </p>
                    </div>
                </div>
                @if (selectedFile() && selectedFile()?.length) {
                <ul class="list-style-none attached-list-items">
                    @for (file of selectedFile(); track $index; let index = $index) {
                    <li class="card p-2 shadow-none attached-list-item" title="{{ file?.name }}">
                        <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                            <i class="fa-regular fa-cloud-arrow-up"></i>
                        </span>
                        <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                            <p class="text-ellipse">{{ file?.name }}</p>
                        </div>
                        <button mat-button class="button-text ms-auto mt-1" title="Delete Item"
                            (click)="removeFile(index)">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </li>

                        }
                    </ul>
                }
            </div>
        </div>

        <div mat-dialog-actions class="dialog-footer gap-8">
            <button mat-button mat-stroked-button class="button-medium flex-1 ms-auto" color="dark"
                    [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-medium flex-1" color="primary"
                    [disabled]="isSubmitInProgress() || !(description?.value)" (click)="submitFeedback()">Submit
            </button>
        </div>
    </div>
</ng-template>

<ng-template #aboutContext>
    <div class="countable-dialog termsDialog" (click)="$event.stopPropagation()" style="width:400px;">
        <div mat-dialog-title class="dialog-header gap-8 align-items-center">
            <span class="badge badge-primary badge-circle icon-bordered-primary">
                <i class="fa-regular fa-lightbulb-on"></i>
            </span>
            <h4 class="title">About Context</h4>
            <p class="fs-14 fw-normal text-gray-10 text-center">In LucaAI, the processing of data is handled through
                Units.
                These units help define the context and output based on the information provided.
            </p>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
            <p class="text-gray-7 mt-2">Here’s how LucaAI works:</p>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            <ul class="list-style-none flexbox-column gap-16 card p-3">
                <li class="flexbox-row flex-nowrap gap-8 align-items-start">
                    <i class="fa-regular fa-circle-check text-success"></i>
                    <p>Input Units: Data provided to Luca, like financial info or client docs. More relevant input
                        improves results.</p>
                </li>
                <li class="flexbox-row flex-nowrap gap-8 align-items-start">
                    <i class="fa-regular fa-circle-check text-success"></i>
                    <p>Output Units: Results from Luca, such as insights, working papers, or reports.</p>
                </li>
                <li class="flexbox-row flex-nowrap gap-8 align-items-start">
                    <i class="fa-regular fa-circle-check text-success"></i>
                    <p>Unit Limit: Luca processes info within a set units limit, tracked in the context window.</p>
                </li>
            </ul>

        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="false">
                Ok
            </button>
        </div>
    </div>
</ng-template>

<ng-template #submitBugSuccess>
    <div class="countable-dialog termsDialog" (click)="$event.stopPropagation()" style="width:400px;">
        <div mat-dialog-title class="dialog-header gap-8 align-items-center">
            <span class="badge badge-success badge-circle icon-bordered-success text-center">
                <i class="fa-regular fa-circle-check text-success"></i>
            </span>
            <h4 class="title">Your report has been successfully submitted</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            <p> Our team will look into the issue shortly</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="false">
                Close
            </button>
        </div>
    </div>
</ng-template>

<ng-template #submitFeedbackSuccess>
    <div class="countable-dialog termsDialog" (click)="$event.stopPropagation()" style="width:400px;">
        <div mat-dialog-title class="dialog-header gap-8 align-items-center ps-5">
            <span class="badge badge-success badge-circle icon-bordered-success text-center">
                <i class="fa-regular fa-circle-check text-success"></i>
            </span>
            <h4 class="title">We appreciate your input!</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content align-items-center">
            <p>Your feedback has been shared successfully</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="false">
                Close
            </button>
        </div>
    </div>
</ng-template>

<ng-template #gettingStarted>
    <div class="countable-dialog video-player-popup" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header gap-0">
            <h4 class="title">Getting Started With LucaAI</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content gap-0 get-started-video-dialog pt-13">
            <div class="d-flex gap-20 justify-content-between align-items-center flex-wrap flex-lg-nowrap">
                <div class="get-left-video v-height">
                    <video controls class="video-block" preload="auto" width="100%" height="100%" #gettingStartedVideo>
                        <source src="{{videoUrl().filePath}}" type="video/mp4">
                    </video>
                    <!-- <h2 class="d-flex justify-content-center">Coming Soon</h2> -->
                </div>
                <div class="bg-blue get-right-list v-height">
                    <div class="template-block-main flexbox-column gap-0 chat-history flex-1">

                        <mat-list role="list">
                            <mat-list-item role="listitem">
                                <ng-container *ngFor="let link of gettingStartedWithLuca;let i=index">
                                    <div class="list-item-content history-list-item justify-content-between list-item-single"
                                         [matTooltip]="link.displayName" matTooltipPosition="right"
                                         (click)="resetLink(link)">
                                        <p class="item-title hover-action fs-12">{{ i + 1 }}.{{ link.displayName }}</p>
                                    </div>
                                </ng-container>

                            </mat-list-item>
                        </mat-list>

                    </div>
                </div>

            </div>

        </div>
    </div>
</ng-template>

<ng-template #noChats>
    <div class="no-data-found">
        <img src="assets/images/ui-uplift-icons/global/empty-component-search-icon-gray.svg" alt="Icon">
        <span class="text-white">No Chats Found</span>
    </div>
</ng-template>